/* 
Enum created just as Spartacus ootb enum, but without the const keyword, to avoid the following error when calling this enum:
    Cannot access ambient const enums when 'isolatedModules' is enabled.
Since when we updated Spartacus to 2211.36 version, it enabled the isolatedModules flag in tsconfig.json
*/
export enum LAUNCH_CALLER {
    QUOTE_ACTION_CONFIRMATION = 'QUOTE_ACTION_CONFIRMATION',
}